"use client"

import { useEffect } from 'react';

/**
 * Componente para detectar quando o usuário está navegando com teclado
 * e adicionar uma classe para melhorar a visibilidade do foco
 */
export default function AccessibleFocus() {
  useEffect(() => {
    // Função para detectar quando o usuário está usando o teclado para navegação
    function handleFirstTab(e: KeyboardEvent) {
      if (e.key === 'Tab') {
        document.body.classList.add('user-is-tabbing');
        
        // Remover o event listener pois já sabemos que o usuário está usando o teclado
        window.removeEventListener('keydown', handleFirstTab);
        
        // Adicionar um event listener para o mouse, para remover a classe quando o usuário voltar a usar o mouse
        window.addEventListener('mousedown', handleMouseDownOnce);
      }
    }
    
    // Função para detectar quando o usuário volta a usar o mouse
    function handleMouseDownOnce() {
      document.body.classList.remove('user-is-tabbing');
      
      // Remover o event listener para o mouse
      window.removeEventListener('mousedown', handleMouseDownOnce);
      
      // Adicionar novamente o event listener para o teclado
      window.addEventListener('keydown', handleFirstTab);
    }
    
    // Iniciar monitorando o uso do teclado
    window.addEventListener('keydown', handleFirstTab);
    
    // Adicionar estilos para o foco quando o usuário está usando teclado
    const style = document.createElement('style');
    style.innerHTML = `
      body:not(.user-is-tabbing) button:focus,
      body:not(.user-is-tabbing) input:focus,
      body:not(.user-is-tabbing) select:focus,
      body:not(.user-is-tabbing) textarea:focus,
      body:not(.user-is-tabbing) a:focus {
        outline: none !important;
      }
      
      body.user-is-tabbing button:focus,
      body.user-is-tabbing input:focus,
      body.user-is-tabbing select:focus,
      body.user-is-tabbing textarea:focus,
      body.user-is-tabbing a:focus {
        outline: 2px solid #60a5fa !important;
        outline-offset: 2px !important;
      }
      
      body.user-is-tabbing .focus-trap:focus {
        outline: 2px solid #60a5fa !important;
        outline-offset: 2px !important;
      }
    `;
    document.head.appendChild(style);
    
    // Cleanup
    return () => {
      window.removeEventListener('keydown', handleFirstTab);
      window.removeEventListener('mousedown', handleMouseDownOnce);
      document.head.removeChild(style);
    };
  }, []);

  return null;
} 